import { trackEvent } from '~/adapters/tracking/tracking';

const accountsSettingsCategory = 'Account Settings';
const modalCategory = 'Modal';

export function sendVaultedPaymentsEvent(label: string): void {
    trackEvent({ category: accountsSettingsCategory, action: 'Payment Method Button Click', label });
}

export function sendHostedFieldsDialogEvent(label: string): void {
    trackEvent({ category: modalCategory, action: 'Add New Card Button Click', label });
}

export function sendRemoveCardModalEvent(label: string): void {
    trackEvent({ category: modalCategory, action: 'Remove Card Button Click', label });
}

export function sendCardResultEvent(label: string): void {
    trackEvent({ category: accountsSettingsCategory, action: 'Payment Methods', label });
}
